module.exports = __webpack_public_path__ + "static/mark-russinovich-78f4d7a9d179af69c178a5c2d0e9463f.jpg";